// require('../../../libs/howler.min.js')
import { Howl, Howler } from '../../../libs/howler.js'

class Sound {
  init (file) {
    let sound = new Howl(file)
    return sound
  }

  startloop (au, sound) {
    var soundId = sound.play(au)
    sound.volume(0.3, soundId)
  }

  stoploop (sound) {
    sound.stop()
  }

  play (x, y, z, au, vol, sound) {
    var soundId = sound.play(au)
    sound.once('play', function () {
      // Set the position of the speaker in 3D space.
      sound.pos(x, y, z, soundId)
      sound.volume(vol, soundId)

      // Tweak the attributes to get the desired effect.
      // sound.pannerAttr({
      //   panningModel: 'HRTF',
      //   refDistance: 1,
      //   rolloffFactor: 1.5,
      //   distanceModel: 'exponential'
      // }, soundId)
    }.bind(), soundId)
  }

  position (x, y, z) {
    Howler.pos(x, y, z)
  }

  mutesound (bg, sprite, sprite2, sprite3, sprite4) {
    Howler.volume(0)
  }

  unmutesound (bg, sprite, sprite2, sprite3, sprite4) {
    Howler.volume(1)
  }
}
export default Sound



// WEBPACK FOOTER //
// ./src/js/views/Sound.js